import { useEffect, useLayoutEffect, useRef } from 'react';

import { LodashHelper } from '../utils';

/**
 * Keeps Formik filter fields and Redux `myFilterParams` in sync.
 * When Redux changes first (e.g. Reset List), Formik can still hold stale values;
 * without a layout reset, the Formik→Redux effect would push stale filters back and can loop updates.
 */
export const useFilterFormikReduxSync = (formik, myFilterParams, dispatch, setMyFilter) => {
  const prevMyFilterParamsRef = useRef();
  const skipFormikToReduxRef = useRef(false);

  useLayoutEffect(() => {
    const normalizedStore = LodashHelper.removeEmptyAndTrim(myFilterParams, true) || {};
    const normalizedPrev =
      LodashHelper.removeEmptyAndTrim(prevMyFilterParamsRef.current ?? {}, true) || {};
    const storeChanged = !LodashHelper.isEqual(normalizedStore, normalizedPrev);

    if (storeChanged) {
      const normalizedFormik = LodashHelper.removeEmptyAndTrim(formik.values, true) || {};
      if (!LodashHelper.isEqual(normalizedFormik, normalizedStore)) {
        // Defer reset out of the layout phase — flushSync during render/lifecycle warns in React 19.
        skipFormikToReduxRef.current = true;
        queueMicrotask(() => {
          formik.resetForm({ values: myFilterParams });
        });
      }
    }
    prevMyFilterParamsRef.current = myFilterParams;
  }, [myFilterParams, formik]);

  useEffect(() => {
    if (skipFormikToReduxRef.current) {
      skipFormikToReduxRef.current = false;
      return;
    }
    const normalizedFormik = LodashHelper.removeEmptyAndTrim(formik.values, true) || {};
    const normalizedStore = LodashHelper.removeEmptyAndTrim(myFilterParams, true) || {};
    if (!LodashHelper.isEqual(normalizedFormik, normalizedStore)) {
      dispatch(setMyFilter(formik.values));
    }
  }, [dispatch, formik.values, myFilterParams, setMyFilter]);
};
